import axios from 'axios';

class ServicePurchaseFiles {
  async uploadFile(root, path, file, onUploadProgress) {
    const formData = new FormData();
    formData.set('json', JSON.stringify({ name: file.name, mimeType: file.type, expectedSize: file.size, lastModified: new Date(file.lastModified) }));
    formData.set('file', file);
    const response = await axios.post(`/api${root}${path}`, formData, { onUploadProgress });
    return response.data;
  }

  async listFiles(root, path) {
    const response = await axios.get(`/api${root}${path}`);
    return response.data;
  }

  async createFolder(root, path, name) {
    const response = await axios.post(`/api${root}${path}`, { name });
    return response.data;
  }

  async deleteFileOrFolder(root, path) {
    const response = await axios.delete(`/api${root}${path}`);
    return response.data;
  }

  async renameFileOrFolder(root, path, oldName, newName) {
    const response = await axios.post(`/api${root}${path}`, { operation: 'RENAME', oldName, newName });
    return response.data;
  }

  async updateDescription(root, path, name, description) {
    const response = await axios.post(`/api${root}${path}`, { operation: 'UPDATE_DESCRIPTION', name, description });
    return response.data;
  }


}

export default new ServicePurchaseFiles();
